import "./inc/utm-params.js";
import "./partial/berkshomes-filter-bridge.js";
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";
// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
// ========================
// == Trigger Tabs By Hash
var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));
triggerTabList.forEach(function (triggerEl) {
    var tabTrigger = new bootstrap.Tab(triggerEl);
    var hash = '#' + triggerEl.href.split("#")[1];
    var tabBtn = document.querySelector(hash + "-tab");
    triggerEl.addEventListener("click", function (event) {
        event.preventDefault();
        tabBtn.click();
    })
})
// END Trigger Tabs By Hash
// ========================
// ========================
// == Add class to main navbar on scroll
const navbar = document.querySelector('#site-nav');
if (navbar) {
    window.addEventListener('scroll', function () {
        let scroll = window.scrollY;
        if (scroll > navbar.offsetTop) {
            navbar.classList.add("header-alt");
        } else {
            navbar.classList.remove("header-alt");
        }
    });
}
// END scrolled
// ========================
// ========================
// == Panzoom =============
const panzoom = document.querySelector(".panzoom");
const panzoom_reset = document.querySelector(".panzoom-reset");
const panZoomImg = document.querySelector('.panzoom__content');
const fpImgLink = document.querySelectorAll("[data-imgurl]");
if (panzoom) {
    const myPanzoom = new Panzoom(panzoom, {
        minScale: 0.5,
        maxScale: 3,
    });
    panzoom_reset.addEventListener("click", function (event) {
        myPanzoom.zoomTo(1);
    })
}
for (const link of fpImgLink) {
    link.addEventListener('click', function () {
        fpImgLink.forEach((e) => { e.classList.remove('active-bg') })
        link.classList.add('active-bg');
        var imgUrl = link.dataset.imgurl;
        console.log(imgUrl);
        panZoomImg.src = imgUrl;
    });
}
// END Panzoom ============
// ========================
/*
* FANCYBOX
*
* The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
* the carousel is first initilaized. To avoid triggering 3 image view events on every
* Fancybox initCarousel action, an imageview event is triggered on the initCarousel
* event, but "done" events are then ignored for 1 second. After 1 second, image view
* events will be triggered as typical.
*/
// Tracks fancybox image views.
let fancyboxEventBlock = false
/** Abstracted event action handler
* @param {import("@fancyapps/ui").Fancybox} fancybox
*/
const doFancyboxOiEvent = (fancybox) => {
    if (fancybox.options.trigger.dataset.oiEventName) {
        let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}
// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", {
    on: {
        initCarousel: (fancybox) => {
            if (!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if (!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
});
/* END FANCYBOX */
// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.
window.addEventListener('load', function () {
    oi.utils.wrap_oi_aspect();
}, false);
// additional website scripts
document.addEventListener("DOMContentLoaded", () => {
    const setScrollPadding = () => {
        const navHeader = document.querySelector('.main-nav');
        const subNav = document.querySelector('.sub-nav-to-stick');
        const headerHeight = navHeader ? navHeader.offsetHeight : 0;
        const subNavHeight = subNav ? subNav.offsetHeight : 0;
        const totalOffset = headerHeight + subNavHeight;
        console.log(totalOffset)
        document.documentElement.style.setProperty(
            '--scroll-padding-offset',
            totalOffset + 'px'
        );
    };
    // initial run
    setScrollPadding();
    // update on resize (mobile / orientation changes)
    window.addEventListener('resize', setScrollPadding);
    // =====================
    // ===== Desktop Menu Toggle =====
    // =====================
    document.querySelectorAll('.open-desktop-menu').forEach(heading => {
        heading.addEventListener('click', () => {
            const targetId = heading.dataset.id;
            if (!targetId) return;
            const targetMenu = document.getElementById(targetId);
            if (!targetMenu || !targetMenu.classList.contains('desktop-menu')) return;
            const isAlreadyOpen = targetMenu.classList.contains('show');
            // Close all other desktop menus
            document.querySelectorAll('.desktop-menu.show').forEach(menu => {
                if (menu !== targetMenu) menu.classList.remove('show');
            });
            // Remove active from all headings
            document.querySelectorAll('.open-desktop-menu.active').forEach(btn => btn.classList.remove('active'));
            // Toggle clicked menu + heading
            if (!isAlreadyOpen) {
                targetMenu.classList.add('show');
                heading.classList.add('active');
                const searchInput = /** @type {HTMLInputElement|null} */ (targetMenu.querySelector('input[type="search"], input[type="text"]'));
                if (searchInput) searchInput.focus();
            } else {
                targetMenu.classList.remove('show');
                heading.classList.remove('active');
            }
        });
    });
    // =====================
    // ===== Mobile Menu Toggle =====
    // =====================
    const fyhExtends = document.querySelector('.menu-mobile-fyh-extends');
    document.querySelectorAll('.toggle-nav-menu-heading').forEach(heading => {
        heading.addEventListener('click', () => {
            const targetId = heading.dataset.id;
            if (!targetId) return;
            const targetMenu = document.getElementById(targetId);
            if (!targetMenu || !targetMenu.classList.contains('toggle-nav-sub-menu')) return;
            const parentmenuItem = targetMenu.closest('.toggle-nav-menu-item');
            const isAlreadyOpen = targetMenu.classList.contains('toggle-nav-sub-menu-active');
            // Close all other open menus
            document.querySelectorAll('.toggle-nav-sub-menu.toggle-nav-sub-menu-active').forEach(menu => {
                if (menu !== targetMenu) {
                    menu.classList.remove('toggle-nav-sub-menu-active');
                    const parent = menu.closest('.toggle-nav-menu-item');
                    if (parent) parent.classList.remove('toggle-nav-menu-item-toggled');
                    // Remove open class from all other headings
                    const otherHeading = parent?.querySelector('.toggle-nav-menu-heading');
                    if (otherHeading) otherHeading.classList.remove('show');
                }
            });
            // Toggle clicked menu
            if (!isAlreadyOpen) {
                targetMenu.classList.add('toggle-nav-sub-menu-active');
                if (parentmenuItem) parentmenuItem.classList.add('toggle-nav-menu-item-toggled');
                heading.classList.add('show'); // add open class
            } else {
                targetMenu.classList.remove('toggle-nav-sub-menu-active');
                if (parentmenuItem) parentmenuItem.classList.remove('toggle-nav-menu-item-toggled');
                heading.classList.remove('show'); // remove open class
            }
            // Toggle FYH mobile extension if data-id="menu-mobile-fyh"
            if (targetId === 'menu-mobile-fyh' && fyhExtends) {
                fyhExtends.classList.toggle('d-none');
            }
        });
    });
    // =====================
    // ===== Close Menus When Clicking Outside =====
    // =====================
    document.addEventListener('click', (e) => {
        // Close desktop menus
        const clickedInsideDesktop = e.target.closest('.desktop-menu.show') || e.target.closest('.open-desktop-menu');
        if (!clickedInsideDesktop) {
            document.querySelectorAll('.desktop-menu.show').forEach(menu => menu.classList.remove('show'));
            document.querySelectorAll('.open-desktop-menu.active').forEach(btn => btn.classList.remove('active'));
        }
    });
    // =====================
    // ===== Toggle Nav Wrapper (Desktop) =====
    // =====================
    const navToggle = document.querySelector('.toggle-nav-button-show-desktop');
    const navWrapper = document.querySelector('.toggle-nav-wrapper');
    const navBurger = document.querySelector('.toggle-nav-button-icon');
    if (navToggle && navWrapper && navBurger) {
        navToggle.addEventListener('click', () => {
            navWrapper.classList.toggle('toggle-nav-wrapper-active');
            navBurger.classList.toggle('open');
        });
    }
    // =====================
    // ===== Plan Card Header Toggle =====
    // =====================
    document.querySelectorAll('.plan-card-list-header').forEach(header => {
        header.addEventListener('click', () => {
            header.classList.toggle('open');
        });
    });
    // =====================
    // ===== Featured Products Tabs =====
    // =====================
    const textBlocks = document.querySelectorAll('.featured-products-text');
    if (textBlocks.length) {
        textBlocks.forEach(el => el.classList.remove('active'));
        textBlocks[0].classList.add('active');
    }
    document.querySelectorAll('.featured-products-content-btn').forEach(button => {
        button.addEventListener('click', function () {
            const targetId = this.dataset.featuredProductText;
            const targetEl = document.getElementById(targetId);
            if (!targetEl) return;
            document.querySelectorAll('.featured-products-text').forEach(el => el.classList.remove('active'));
            targetEl.classList.add('active');
        });
    });
    // =====================
    // ===== Featured Products Carousel =====
    // =====================
    // Add 'active' to first tab-pane featured model cta
    const buttons = document.querySelectorAll('.featured-products-content-btn');
    if (buttons.length) {
        buttons.forEach(btn => btn.classList.remove('active')); // Remove active from all
        buttons[0].classList.add('active'); // Add active to first
    }
    // Add 'show active' to first tab-pane
    const tabPanes = document.querySelectorAll('.featured-products-cards .tab-pane');
    if (tabPanes.length) {
        tabPanes.forEach(pane => pane.classList.remove('show', 'active'));
        tabPanes[0].classList.add('show', 'active');
    }
    document.querySelectorAll('.featured-products-cards .tab-pane').forEach(pane => {
        const carousel = pane.querySelector('.carousel-thumbnails');
        const prevBtn = pane.querySelector('.carousel-image-button-left');
        const nextBtn = pane.querySelector('.carousel-image-button-right');
        if (!carousel || !prevBtn || !nextBtn) return;
        const getItemScrollWidth = () => {
            const firstItem = carousel.querySelector('li');
            if (!firstItem) return 0;
            const itemWidth = firstItem.offsetWidth;
            const styles = window.getComputedStyle(carousel);
            const gap = parseFloat(styles.columnGap || styles.gap || 0);
            return itemWidth + gap;
        };
        prevBtn.addEventListener('click', () => {
            carousel.scrollBy({ left: -getItemScrollWidth(), behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', () => {
            carousel.scrollBy({ left: getItemScrollWidth(), behavior: 'smooth' });
        });
        const updateNavState = () => {
            const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
            prevBtn.classList.toggle(
                'carousel-image-button-disabled',
                carousel.scrollLeft <= 0
            );
            nextBtn.classList.toggle(
                'carousel-image-button-disabled',
                carousel.scrollLeft >= maxScrollLeft - 1
            );
        };
        carousel.addEventListener('scroll', updateNavState);
        window.addEventListener('resize', updateNavState);
        updateNavState();
    });
    // =====================
    // ===== Page Menu Toggle =====
    // =====================
    const menuWrappers = document.querySelectorAll('.page-menu-wrapper');
    menuWrappers.forEach(wrapper => {
        const pageMenuTitle = wrapper.querySelector('.page-menu-title');
        const menuList = wrapper.querySelector('.page-menu-list');
        if (pageMenuTitle && menuList) {
            pageMenuTitle.addEventListener('click', () => {
                pageMenuTitle.classList.toggle('show');
                menuList.classList.toggle('show');
            });
        }
    });
    // =====================
    // ===== Listing Filters Dropdowns =====
    // =====================
    function closeDropdowns(wrappers, activeClass, dropdownClass) {
        wrappers.forEach(wrapper => {
            const dropdown = wrapper.querySelector(dropdownClass);
            if (dropdown) dropdown.classList.add('d-none');
            wrapper.classList.remove(activeClass);
        });
    }
    const filterWrappers = document.querySelectorAll('.filter-select-wrapper');
    filterWrappers.forEach(wrapper => {
        const dropdown = wrapper.querySelector('.filter-select-dropdown');
        if (!dropdown) return;
        wrapper.addEventListener('click', event => {
            const isActive = wrapper.classList.contains('filter-select-wrapper-active');
            if (isActive) {
                dropdown.classList.add('d-none');
                wrapper.classList.remove('filter-select-wrapper-active');
                event.stopPropagation();
                return;
            }
            dropdown.classList.remove('d-none');
            wrapper.classList.add('filter-select-wrapper-active');
            filterWrappers.forEach(w => {
                if (w !== wrapper) {
                    const otherDropdown = w.querySelector('.filter-select-dropdown');
                    if (otherDropdown) otherDropdown.classList.add('d-none');
                    w.classList.remove('filter-select-wrapper-active');
                }
            });
            event.stopPropagation();
        });
    });
    const sortButtons = document.querySelectorAll('.btn-sort');
    sortButtons.forEach(button => {
        button.addEventListener('click', event => {
            const dropdown = button.parentElement.querySelector('.list-dropdown');
            if (!dropdown) return;
            dropdown.classList.toggle('active');
            document.querySelectorAll('.list-dropdown.active').forEach(d => {
                if (d !== dropdown) d.classList.remove('active');
            });
            event.stopPropagation();
        });
    });
    document.addEventListener('click', () => {
        closeDropdowns(filterWrappers, 'filter-select-wrapper-active', '.filter-select-dropdown');
        document.querySelectorAll('.list-dropdown.active').forEach(d => d.classList.remove('active'));
    });
    // open up modal like filter on mobile
    const wrapper = document.querySelector(".filter-sort-wrapper");
    const toggle = document.querySelector(".filter-sort-toggle");
    const closeBtn = document.querySelector(".filter-sort-close-btn");
    const doneBtn = document.querySelector(".filter-sort-done-btn");
    toggle?.addEventListener("click", () => {
        wrapper?.classList.toggle("active");
    });
    closeBtn?.addEventListener("click", () => {
        wrapper?.classList.remove("active");
    });
    doneBtn?.addEventListener("click", () => {
        wrapper?.classList.remove("active");
    });
    // =====================
    // ===== Detail Menu Scroll & Link Active =====
    // =====================
    const detailMenu = document.querySelector('.sub-nav-to-stick');
    if (detailMenu) {
        const links = detailMenu.querySelectorAll('a');
        const menuOffsetTop = detailMenu.getBoundingClientRect().top + window.pageYOffset;
        window.addEventListener('scroll', () => {
            detailMenu.classList.toggle('active', window.pageYOffset > menuOffsetTop);
        });
        links.forEach(link => {
            link.addEventListener('click', () => {
                links.forEach(l => l.classList.remove('active'));
                link.classList.add('active');
            });
        });
    }
    // ======================
    // Accordion logic
    // ======================
    const accordionSections = document.querySelectorAll(".accordion-section-wrapper");
    if (accordionSections.length) {
        const mobileQuery = window.matchMedia("(max-width: 991.98px)");
        const setAccordionState = (button, panel, isOpen) => {
            button.setAttribute("aria-expanded", isOpen ? "true" : "false");
            button.classList.toggle("detail-section-heading-open", isOpen);
            panel.style.height = isOpen ? "auto" : "";
        };
        const accordions = [];
        accordionSections.forEach(section => {
            const button = section.querySelector(".detail-section-heading");
            const panel = section.querySelector(".accordion-toggle-content");
            if (!button || !panel) return;
            accordions.push({
                button,
                panel,
                defaultOpen: "accordionDefaultOpen" in section.dataset
            });
            button.addEventListener("click", () => {
                if (!mobileQuery.matches) return;
                setAccordionState(
                    button,
                    panel,
                    button.getAttribute("aria-expanded") !== "true"
                );
            });
        });
        const syncAccordions = () => {
            accordions.forEach(({ button, panel, defaultOpen }) => {
                if (mobileQuery.matches) {
                    button.disabled = false;
                    setAccordionState(button, panel, defaultOpen);
                } else {
                    button.disabled = true;
                    button.setAttribute("aria-expanded", "true");
                    button.classList.remove("detail-section-heading-open");
                    panel.style.height = "";
                }
            });
        };
        syncAccordions();
        mobileQuery.addEventListener("change", syncAccordions);
    }
    // ======================
    // Plan detail dropdown
    // ======================
    const trigger = document.querySelector(".agent-community-plan-comm");
    const dropdown = document.querySelector("#available-in-location");
    if (trigger && dropdown) {
        trigger.addEventListener("click", () => {
            trigger.classList.toggle("active");
            dropdown.classList.toggle("d-none");
        });
    }
    // =========================================
    // Floorplan dropdown + panel toggle
    // =========================================
    document.querySelectorAll(".detail-section-floorplan-wrapper").forEach(wrapper => {
        const panels = wrapper.querySelectorAll(".floorplan-panel");
        const btn = wrapper.querySelector(".floor-plans-btn");
        const list = wrapper.querySelector(".floorplan-list");
        // Guard: wrapper exists but feature not present
        if (!panels.length || !btn || !list) return;
        // -------------------------
        // Dropdown toggle
        // -------------------------
        btn.addEventListener("click", () => {
            list.classList.toggle("d-none");
        });
        // -------------------------
        // Tab + panel switching
        // (event delegation)
        // -------------------------
        wrapper.addEventListener("click", e => {
            const item = e.target.closest(".list-dropdown-item");
            if (!item || !wrapper.contains(item)) return;
            const targetId = item.dataset.id;
            if (!targetId) return;
            // Remove active from all tabs
            wrapper
                .querySelectorAll(".list-dropdown-item.active")
                .forEach(el => el.classList.remove("active"));
            // Hide all panels
            panels.forEach(panel => panel.classList.add("d-none"));
            // Activate clicked tab
            item.classList.add("active");
            // Show matching panel
            const target = wrapper.querySelector(
                `#${CSS.escape(targetId)}`
            );
            if (target) target.classList.remove("d-none");
            // Update button text
            btn.textContent = item.textContent.trim();
            // Close dropdown
            list.classList.add("d-none");
        });
    });
    // script to share/copy url
    // Step 1: Populate the input when modal opens (no need to wait)
    const shareButtons = document.querySelectorAll('.share-link-modal-btn');
    if (shareButtons.length) {
        shareButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                const modalInput = document.querySelector('.share-form-input');
                if (modalInput) {
                    modalInput.value = window.location.href;
                    // Optional: select the text
                    modalInput.select();
                    modalInput.setSelectionRange(0, 99999); // For mobile
                }
            });
        });
    }
    // Step 2: Copy input value when clicking .btn-copy-link
    const copyButtons = document.querySelectorAll('.btn-copy-link');
    if (copyButtons.length) {
        copyButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                const modalInput = document.querySelector('.share-form-input');
                if (!modalInput) return;
                const textToCopy = modalInput.value;
                // Modern approach
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(textToCopy)
                        .then(() => showCopiedText(btn))
                        .catch(() => fallbackCopy(modalInput, btn));
                } else {
                    fallbackCopy(modalInput, btn);
                }
            });
        });
    }
    // Fallback using execCommand
    function fallbackCopy(input, btn) {
        if (!input || !btn) return;
        input.select();
        input.setSelectionRange(0, 99999);
        try {
            const successful = document.execCommand('copy');
            if (successful) showCopiedText(btn);
        } catch (err) {
            console.error('Fallback copy failed', err);
        }
    }
    function showCopiedText(btn) {
        if (!btn) return;
        const originalText = btn.textContent;
        btn.textContent = 'Copied!';
        setTimeout(() => {
            btn.textContent = originalText;
        }, 1500);
    }
    // ======================
    // Gallery List/Detail page script
    // ======================
    // 1️⃣ Toggle choose plan dropdown
    const btnChoosePlan = document.querySelector(".btn-choose-plan");
    const planListDropdown = document.querySelector(".list-dropdown");
    if (btnChoosePlan && planListDropdown) {
        btnChoosePlan.addEventListener("click", (e) => {
            e.stopPropagation();
            planListDropdown.classList.toggle("d-none");
        });
        planListDropdown.addEventListener("click", (e) => e.stopPropagation());
        document.addEventListener("click", () => {
            if (!planListDropdown.classList.contains("d-none")) {
                planListDropdown.classList.add("d-none");
            }
        });
    }
    // 2️⃣ Photo gallery load more
    const items = document.querySelectorAll(".photo-gallery-list-item");
    const loadMoreWrapper = document.querySelector(".load-more-wrapper");
    const loadMoreBtn = document.querySelector(".load-more-btn");
    const VISIBLE_COUNT = 24;
    if (items.length > 0 && loadMoreWrapper && loadMoreBtn) {
        if (items.length <= VISIBLE_COUNT) {
            loadMoreWrapper.classList.add("d-none");
        } else {
            items.forEach((item, index) => {
                if (index >= VISIBLE_COUNT) item.classList.add("d-none");
            });
            loadMoreBtn.addEventListener("click", () => {
                items.forEach(item => item.classList.remove("d-none"));
                loadMoreWrapper.classList.add("d-none");
            });
        }
    }
    // 3️⃣ Page menu toggle
    const title = document.querySelector(".page-menu-alt-title");
    const list = document.querySelector(".page-menu-alt-list");
    if (title && list) {
        title.addEventListener("click", () => list.classList.toggle("show"));
    }
    // 4️⃣ Gallery search toggle
    const galSearchBtn = document.querySelector(".btn-gallery-search");
    const galSearchInput = document.querySelector(".gallery-search-form");
    if (galSearchBtn && galSearchInput) {
        galSearchBtn.addEventListener("click", () => {
            galSearchInput.classList.toggle("d-none");
        });
    }
    // event detail page - other event dropdown script
    const btnOtherEvents = document.querySelectorAll('.btn-other-events-and-promos');
    btnOtherEvents.forEach(button => {
        button.addEventListener('click', event => {
            const dropdown = button.parentElement.querySelector('.list-dropdown');
            if (!dropdown) return;
            dropdown.classList.toggle('d-none');
            document.querySelectorAll('.list-dropdown.active').forEach(d => {
                if (d !== dropdown) d.classList.remove('d-none');
            });
            event.stopPropagation();
        });
    });
    // wrap * inside span to make it red
    // Target only labels inside forms
    document.querySelectorAll("form label").forEach(function (label) {
        // Only process labels that contain an asterisk
        if (label.textContent.includes("*")) {
            // Replace '*' with a span, leaving other text intact
            label.innerHTML = label.innerHTML.replace(/\*(?=\s|$)/g, '<span class="text-danger">*</span>');
        }
    });
});
// add active class to subnav items based on page url
(function () {
    const menuLinks = document.querySelectorAll('.page-menu-list-item a');
    if (!menuLinks.length) return;
    const normalize = path => path.replace(/\/$/, '');
    const currentPath = normalize(window.location.pathname);
    menuLinks.forEach(link => {
        const rawHref = link.getAttribute('href');
        if (!rawHref) return;
        // ✅ Case 1: Anchor link (#foo)
        if (rawHref.startsWith('#')) {
            link.addEventListener('click', function () {
                // Remove active from all
                menuLinks.forEach(l => l.classList.remove('active'));
                // Add active to clicked link
                this.classList.add('active');
            });
            return;
        }
        // ✅ Case 2: URL link
        if (link.origin !== window.location.origin) return;
        const linkPath = normalize(link.pathname);
        if (linkPath === currentPath) {
            link.classList.add('active');
        }
    });
})();
// faqs on page build process prepare
(() => {
    document.addEventListener('click', (e) => {
        const button = e.target.closest('.accordion-button');
        if (!button) return;
        const faqWrap = button.closest('.accordion-wrap');
        if (!faqWrap) return;
        const answer = faqWrap.querySelector('.accordion-collapse-wrap');
        if (!answer) return;
        button.classList.toggle('open');
        answer.classList.toggle('d-none');
    });
})();
// detail page hero section has this photo counter
// that needs to be pushed exactly by sidebar with
// script for that
(() => {
    const OFFSET_PX = 0;

    const applySidebarWidth = (headline, container, targets) => {
        // Only proceed if required elements exist
        if (!headline || !container) return null;

        const headlineWidth = headline.getBoundingClientRect().width;
        const containerRect = container.getBoundingClientRect();
        const viewportWidth = window.innerWidth;

        // Space between container right edge and viewport
        const rightSpace = Math.max(
            0,
            Math.round(viewportWidth - containerRect.right)
        );

        // Calculate sidebar width safely
        const sidebarWidth = Math.max(
            0,
            Math.round(headlineWidth - rightSpace - OFFSET_PX)
        );

        // Apply to both wrappers if they exist
        targets.forEach((el) => {
            if (el) {
                el.style.setProperty("--sidebarWidth", `${sidebarWidth}px`);
            }
        });

        return {
            headlineWidth,
            rightSpace,
            sidebarWidth
        };
    };

    const updateSidebarWidth = () => {
        const communityResult = applySidebarWidth(
            document.querySelector(".model-header-headline"),
            document.querySelector(".custom-container"),
            [
                document.querySelector(".model-header-tile-wrapper"),
                document.querySelector(".community-overview-section-wrapper"),
            ]
        );

        if (communityResult) {
            console.log(communityResult);
        }

        applySidebarWidth(
            document.querySelector(".plan-detail-pages-section-wrapper .agent-section-wrapper"),
            document.querySelector(".plan-detail-section-wrapper .container"),
            [document.querySelector(".plan-detail-page-wrapper .plan-header-wrapper")]
        );
    };

    // Initial calculation
    updateSidebarWidth();

    // Update on resize (debounced)
    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateSidebarWidth, 100);
    });
})();

// Form redirect after successful submission
document.querySelectorAll("form[data-oi-form-autoload]").forEach(function (formEl) {
    window.addEventListener("oi.loaded.form." + formEl.id, function () {
        oi.loaded.form[formEl.id].addSuccessAction = function (response) {
            if (response.data.data.redirect_url) {
                window.location.href = response.data.data.redirect_url;
            }
        };
    });
});
